
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { MigrationSourceModel } from 'models/generated/Distribution.Api.Models.Migration.MigrationSource';


const _distribution_MigrationSourceControllerHelper = new Map<string, Object>();
_distribution_MigrationSourceControllerHelper.set('GetMigrationSources', MigrationSourceModel);


export const distribution_MigrationSourceControllerHelper = _distribution_MigrationSourceControllerHelper;

